import Vue from "vue";
import VueRouter from "vue-router";
import LoginPage from "../views/NewItemLoginPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: LoginPage
  },
  {
    path: "/homePage",
    name: "homePage",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/NewItemSubmissionsComponent.vue"
      )
  },
  {
    path: "/createNewSubmission",
    name: "createNewSubmission",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/ManageSupplierUsersView.vue"
      )
  },
  {
    path: "/createNewEUSubmission",
    name: "createNewEUSubmission",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/ManageSupplierUsersView.vue"
      )
  },
  {
    path: "/editSubmission",
    name: "editSubmission",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/ManageSupplierUsersView.vue"
      )
  },
  {
    path: "/editEuSubmission",
    name: "editEuSubmission",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/ManageSupplierUsersView.vue"
      )
  },
  {
    path: "/maintainancePage",
    name: "maintainancePage",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/MaintainancePage.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
